<template>

  <tr v-if="true"
  :class="{'selected': selected[item.id]}">
    <td class="sticky">
      <v-layout align-center>
        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.id] ? 'color1' : ''"> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <transition
        name="slide-x-transition"
        appear
        hide-on-leave
        mode="out-in">
          <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
        </transition>

        <v-list-item-avatar
        color="text"
        class="headline font-weight-light white--text mr-2">
          {{ (item.name || '?').charAt(0) }}
        </v-list-item-avatar>
        <div v-html="highlightedName">
          
        </div>
        <span v-if="item.is_default" class="ml-2 color1--text caption">
          (default)
        </span>

      </v-layout>
    </td>
    <td>
      <span 
      class=""
      v-html="highlightedID">
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['item', 'itemsMeta', 'selected', 'searchFilters'],
  computed: {
    highlightedID () {
      var replacedStr = (this.searchFilters.id || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.id.toString().replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      if (!this.searchFilters.id) {
        return replacedStr
      }
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    },
    highlightedName () {
      var replacedStr = (this.searchFilters.name || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      if (!this.searchFilters.name) {
        return replacedStr
      }
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  }
}
</script>


<style scoped lang="scss">

</style>
